import * as React from 'react';

import SVGBase from '../svg-base/svg-base';

export interface ExclamationProps {
    fill?: string;
    title?: string;
    height?: string;
    width?: string;
    viewBox?: string;
}

const Exclamation = ({ fill, title, height, width, ...rest }: ExclamationProps) => (
    <SVGBase viewBox="0 0 16.5 16.5" height={height} width={width} title={title} fill={fill} {...rest}>
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M0 8.25a8.25 8.25 0 1 1 16.5 0 8.25 8.25 0 0 1-16.5 0ZM8.25 3.6a.9.9 0 0 1 .9.9V9a.9.9 0 0 1-1.8 0V4.5a.9.9 0 0 1 .9-.9Zm.61 7.73a.9.9 0 0 1 .068 1.271l-.009.01a.9.9 0 1 1-1.338-1.204l.009-.01a.9.9 0 0 1 1.27-.067Z"
        />
    </SVGBase>
);

export default Exclamation;
